import {Component, EventEmitter, Injector, Output, ViewChild} from '@angular/core';
import {User} from "../../models/user";
import {Athlete} from "../../models/athlete";
import {Company} from "../../models/company";
import {UserService} from "../../services/user/user.service";
import {CompanyService} from "../../services/company/company.service";
import {ActivatedRoute, Router} from "@angular/router";
import Swal from "sweetalert2";
import {BaseComponent} from "../../components/base/base.component";


@Component({
    selector: 'app-register-user',
    templateUrl: './register-user.component.html',
    styleUrls: ['./register-user.component.scss']
})
export class RegisterUserComponent extends BaseComponent {

    private readonly STEP_STORAGE_KEY = 'register-user-step';
    private readonly DATA_STORAGE_KEY = 'register-user-data';

    @Output('step') public stepEmit: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('disableBtn') parentDisableBtn: any;
    @ViewChild('disableAdultBtn') adultDisableBtn: any;

    stepNumber: number = 1;
    steps: any[] = [];

    company: Company | undefined;
    companyId: string | undefined;
    companyRules: string | undefined;
    OTPCode: string = '';

    typesOfAccount: string[] = ['userAthlete', 'userParent', 'agentCommerce', 'agentFreelance', 'agentPrivate'];
    typeOfAccount: string = this.typesOfAccount[1];
    citizenshipTypes = [
        {id: 'italiano', name: 'Italiano'},
        {id: 'europeo_non_ita', name: 'Europeo non ITA'},
        {id: 'extra_comunitario_eu', name: 'Extra comunitario EU'}
    ];
    selectedAthleteCitizenshipType: string = '';

    newUser: User = new User();
    listOfAthletes: Athlete[] = [];
    newAthlete: Athlete = new Athlete();
    allAthletesAreValid: boolean = false;
    tutorDocumentFront: File | undefined;
    tutorDocumentBack: File | undefined;
    tutorDocumentFrontProvided: boolean = false;
    tutorDocumentBackProvided: boolean = false;

    isEditingAthlete: boolean = false;
    athleteIndex: number = -1;

    termsAndConditionAccepted: boolean = false;
    privacyAccepted: boolean = false;
    companyRulesAccepted: boolean = false;

    companyNotFound = false;

    responseFront: string = '';
    responseBack: string = '';

    disableContinueButton: boolean = true;

    showPassword: boolean = false;

    manualOnboarding: boolean = false;


    constructor(
        public serviceInjector: Injector,
        public userService: UserService,
        public router: Router,
        public companyService: CompanyService,
        private route: ActivatedRoute) {
        super(serviceInjector);
    }

    async ngOnInit(): Promise<void> {
        this.manualOnboarding = !!this.route.snapshot.data['manualOnboarding'];

        if (this.manualOnboarding && this.utils.getJwtUserGroup() !== 'companymanager') {
            await this.router.navigate(['/companies/dashboard']);
            return;
        }

        this.newUser.subtype = this.typeOfAccount;

        if (!this.manualOnboarding) {
            this.restoreFormData();

            const savedStep = localStorage.getItem(this.STEP_STORAGE_KEY);
            if (savedStep) {
                this.stepNumber = Number(savedStep);
                this.stepEmit.emit(this.stepNumber);
            }
        }

        if (this.manualOnboarding) {
            this.companyId = localStorage.getItem('wisper_companyId') ?? undefined;
            if (this.companyId) {
                const companyResponse = await this.companyService.getCompanyById(this.companyId);
                this.company = companyResponse?.data;
                this.companyRules = this.company?.rulesUrl;
            }
        } else {
            this.company = await this.companyService.getCompanyFromDomain(window.location.hostname);
            this.companyId = this.company?.id;
            this.companyRules = this.company?.rulesUrl;
        }

        if (!this.companyId) {
            this.companyNotFound = true;
        }
    }


    setTypeOfAccount(type: string) {
        this.typeOfAccount = type;
        this.newUser.subtype = type;
    }

    async nextStep() {
        console.log(this.stepNumber)
        if (this.stepCheck()) {

            if (this.stepNumber === 1) {
                this.listOfAthletes = [];
                this.showInfoMessage('Inserisci le informazioni del genitore/tutore');
            }
            if (this.stepNumber === 2) {
                if (await this.checkExistingUser(this.newUser.firstName, this.newUser.lastName, this.newUser.phone!)) {
                    this.showErrorMessage('Utente già registrato');
                    return;
                }
                this.showInfoMessage('Completa le informazioni dell\'atleta');
                if (this.typeOfAccount === this.typesOfAccount[0]) {
                    this.adultDisableBtn.nativeElement.disabled = true;
                    this.newAthlete = new Athlete();
                    this.newAthlete.firstName = this.newUser.firstName;
                    this.newAthlete.lastName = this.newUser.lastName;
                    this.newAthlete.citizenshipType = this.selectedAthleteCitizenshipType;
                    this.listOfAthletes = [this.newAthlete];


                }

                if (this.typeOfAccount === this.typesOfAccount[1]) {
                    this.parentDisableBtn.nativeElement.disabled = true;
                    this.responseFront = await this.uploadDocument(this.tutorDocumentFront!);
                    this.responseBack = await this.uploadDocument(this.tutorDocumentBack!);

                    if (this.responseFront && this.responseBack) {
                        this.newUser['documentUrlFront'] = this.responseFront;
                        this.newUser['documentUrlBack'] = this.responseBack;
                    }

                }
            }

            if (this.stepNumber === 3) {
                this.showInfoMessage('Accetta i termini e le condizioni del servizio');
                this.newUser.athletes = [...this.listOfAthletes];
                // this.allAthletesAreValid = this.checkAthletesAreValid();
            }

            if (this.stepNumber === 4 && !this.manualOnboarding) {
                this.showInfoMessage('Per concludere la fase di registrazione, controlla la tua casella di posta elettronica e inserisci il codice OTP ricevuto');
            }

            this.stepNumber++;
            localStorage.setItem(this.STEP_STORAGE_KEY, this.stepNumber.toString());
            this.saveFormData();
            this.stepEmit.emit(this.stepNumber);
        }
    }

    previousStep() {
        if (this.stepNumber === 1) {
            this.listOfAthletes = [];
            this.stepNumber = 1;
        }

        this.stepNumber--;
        localStorage.setItem(this.STEP_STORAGE_KEY, this.stepNumber.toString());
        this.saveFormData();
        this.stepEmit.emit(this.stepNumber)
    }

    stepCheck() {
        if (this.typeOfAccount === this.typesOfAccount[1]) {
        }
        return true;
    }

    openModal() {
        if (!this.isEditingAthlete) {
            this.newAthlete = new Athlete();
        }
        this.ngxSmartModalService.getModal('addAthlete').open();
    }

    closeModal() {
        this.allAthletesAreValid = this.checkAthletesAreValid();
        this.ngxSmartModalService.getModal('addAthlete').close();
    }

    addAthleteToList(athlete: Athlete) {
        console.log('addAthleteToList: ', athlete)
        if (this.athleteIsValid(athlete)) {
            this.closeModal();
            if (this.isEditingAthlete) {
                this.listOfAthletes[this.athleteIndex] = this.newAthlete;
                if (this.typeOfAccount === this.typesOfAccount[1]) this.newAthlete = new Athlete();
                this.isEditingAthlete = false;
            } else {
                this.listOfAthletes.push(this.newAthlete);
            }

        }
    }

    editAthlete(i: number) {
        this.newAthlete = this.listOfAthletes[i];
        this.isEditingAthlete = true;
        this.athleteIndex = i;
        this.openModal();
    }

    parentIsValid(parent: User){
        return(
            parent.firstName !== '' &&
            parent.lastName !== '' &&
            parent.email !== '' &&
            parent.phone !== '' &&
            parent.fiscalCode !== '' &&
            parent.password !== '' &&
            this.tutorDocumentFrontProvided &&
            this.tutorDocumentBackProvided
        )
    }


    athleteIsValid(athlete: Athlete) {
        return athlete.firstName !== '' &&
            athlete.lastName !== '' &&
            athlete.bornDate !== '' &&
            athlete.bornCity !== '' &&
            athlete.fiscalCode !== '' &&
            !!athlete.citizenshipType;
    }

    checkAthletesAreValid() {
        return this.listOfAthletes.every(athlete => this.athleteIsValid(athlete));
    }

    deleteAthlete(i: number) {
        Swal.fire({
            title: `Sei sicuro di voler rimuovere ${this.listOfAthletes[i].firstName} ${this.listOfAthletes[i].lastName}?`,
            //text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, rimuovi'
        }).then((result) => {
            if (result.isConfirmed) {
                this.listOfAthletes.splice(i, 1);
                Swal.fire(
                    'Rimosso!',
                    'Atleta rimosso',
                    'success'
                )
            }
        })
    }

    backToLogin() {
        localStorage.removeItem(this.STEP_STORAGE_KEY);
        localStorage.removeItem(this.DATA_STORAGE_KEY);
        localStorage.removeItem(this.DATA_STORAGE_KEY + '-password');
        if (this.manualOnboarding) {
            this.router.navigate(['/companies/athletes']);
            return;
        }
        this.router.navigate(['/login'])
    }

    async sendRegistrationUser() {
        this.disableContinueButton = false
        try {
            if (!this.checkAthletesAreValid()) {
                this.disableContinueButton = true;
                Swal.fire({
                    icon: 'error',
                    title: "Completa la nazionalità dell'atleta"
                });
                return;
            }

            this.newUser.acceptTerms = new Date().toISOString();
            this.newUser.acceptPrivacy = new Date().toISOString();
            this.newUser.acceptCompanyRules = new Date().toISOString();
            this.newUser.companyId = this.companyId;
            this.newUser.athletes = [...this.listOfAthletes];

            let response = this.manualOnboarding
                ? await this.userService.athleteOnboarding(this.newUser)
                : await this.userService.register(this.newUser);

            if (response.success) {
                if (this.manualOnboarding) {
                    this.stepNumber = 6;
                    this.stepEmit.emit(this.stepNumber);
                } else {
                    localStorage.setItem(this.STEP_STORAGE_KEY, this.stepNumber.toString());
                    this.nextStep();
                }
                this.disableContinueButton = true
            } else {
                this.disableContinueButton = true
                if (response.code === "USER_ALREADY_EXIST") {
                    Swal.fire({
                        icon: 'error',
                        title: "Errore, email già registrata con un altro utente!"
                    })
                } else {
                    this.disableContinueButton = true
                    Swal.fire({
                        icon: 'error',
                        title: "Errore durante la creazione dell'utente, riprovare"
                    })
                }
            }
        } catch (e) {
            console.error('error registration user: ', e);
        }
    }

    /*getAtheleteCategoryName(athlete: Athlete){
      return this.categories.find( (category: Category) => category.id === athlete.categoryId).name;
    }*/

    async checkOTP(otp: string, email: string) {

        // ! uso il companyService perché alla fine non cambia niente, e non duplico il codice
        let response = await this.companyService.checkOTP(otp, email);
        console.log('checkOTP: ', response);
        if (response.success) {
            localStorage.removeItem(this.STEP_STORAGE_KEY);
            localStorage.removeItem(this.DATA_STORAGE_KEY);
            this.nextStep();
        } else {
            Swal.fire({icon: 'error', title: 'Non è stato possibile verificare il codice OTP inserito'})
        }
    }

    chooseDocumentFront(event: any) {
        this.tutorDocumentFront = event.target.files[0];
        this.tutorDocumentFrontProvided = true;
    }

    chooseDocumentBack(event: any) {
        this.tutorDocumentBack = event.target.files[0];
        this.tutorDocumentBackProvided = true;
    }

    async uploadDocument(file: File) {
        console.log('in uploadDocument', file)
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file)

        const {success, data} = this.manualOnboarding
            ? await this.uploadUserAuthenticated(formData)
            : await this.userService.uploadUser(formData);

        if (success) return data;

        return null;

    }

    async uploadUserAuthenticated(formData: FormData) {
        try {
            return await this.userService.uploadUserAuthenticated(formData);
        } catch (e) {
            console.error('error uploadUserAuthenticated: ', e);
            return { success: false, data: null };
        }
    }

    async checkExistingUser(firstName: string, lastName: string, phone: string) {
        const params = {
            firstName: firstName,
            lastName: lastName,
            phone: phone,
            companyId: this.companyId
        }
        let response: any = await this.userService.checkExistingUser(params)
        return !!response.data;

    }

    getCitizenshipName(idOrName: any): string {
        if (!idOrName) {
            return '';
        }
        if (!Array.isArray(this.citizenshipTypes)) {
            return idOrName;
        }
        const found = this.citizenshipTypes.find(t =>
            t.id === idOrName || t.id === String(idOrName) || t.name === idOrName
        );
        return found ? found.name : idOrName;
    }

    private saveFormData(): void {
        const data: any = {
            newUser: { ...this.newUser },
            typeOfAccount: this.typeOfAccount,
            selectedAthleteCitizenshipType: this.selectedAthleteCitizenshipType,
            listOfAthletes: this.listOfAthletes.map(a => ({ ...a })),
            termsAndConditionAccepted: this.termsAndConditionAccepted,
            privacyAccepted: this.privacyAccepted,
            companyRulesAccepted: this.companyRulesAccepted,
            responseFront: this.responseFront,
            responseBack: this.responseBack,
        };
        // Salva la password in localStorage per mantenerla dopo refresh (persistente)
        if (this.newUser.password) {
            try {
                localStorage.setItem(this.DATA_STORAGE_KEY + '-password', this.newUser.password);
            } catch (e) {
                console.error('Error saving password to localStorage', e);
            }
        } else {
            localStorage.removeItem(this.DATA_STORAGE_KEY + '-password');
        }
        // Non salvare oggetti File (non serializzabili)
        // Rimuoviamo la password dall'oggetto salvato su localStorage per sicurezza
        if (data.newUser) delete data.newUser.password;
        localStorage.setItem(this.DATA_STORAGE_KEY, JSON.stringify(data));
    }

    private restoreFormData(): void {
        const raw = localStorage.getItem(this.DATA_STORAGE_KEY);
        if (!raw) return;
        try {
            const data = JSON.parse(raw);
            if (data.newUser) {
                Object.assign(this.newUser, data.newUser);
            }
            if (data.typeOfAccount) {
                this.typeOfAccount = data.typeOfAccount;
                this.newUser.subtype = data.typeOfAccount;
            }
            if (data.selectedAthleteCitizenshipType) {
                this.selectedAthleteCitizenshipType = data.selectedAthleteCitizenshipType;
            }
            if (data.listOfAthletes && data.listOfAthletes.length > 0) {
                this.listOfAthletes = data.listOfAthletes.map((a: any) => {
                    const athlete = new Athlete();
                    Object.assign(athlete, a);
                    return athlete;
                });
            }
            if (data.termsAndConditionAccepted !== undefined) {
                this.termsAndConditionAccepted = data.termsAndConditionAccepted;
            }
            if (data.privacyAccepted !== undefined) {
                this.privacyAccepted = data.privacyAccepted;
            }
            if (data.companyRulesAccepted !== undefined) {
                this.companyRulesAccepted = data.companyRulesAccepted;
            }
            if (data.responseFront) {
                this.responseFront = data.responseFront;
            }
            if (data.responseBack) {
                this.responseBack = data.responseBack;
            }
            // restore password from localStorage if present
            try {
                const pw = localStorage.getItem(this.DATA_STORAGE_KEY + '-password');
                if (pw) {
                    this.newUser.password = pw;
                }
            } catch (e) {
                console.error('Error restoring password from localStorage', e);
            }
        } catch (e) {
            console.error('Error restoring registration form data:', e);
        }
    }
}
